module.exports = __webpack_public_path__ + "assets/8a2950020c843ef0d23232e037e3fbda.png";